
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/timeline/templates/drop_notification"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "Moved moment from\n<div class='from'></div>\nto\n<div class='to'></div>\n<div class='opal_ui ui_btn undo'>\n  <span class='label'>\n    Undo Move\n  </span>\n</div>\n<div class='sprite-global glyph-dismiss'></div>\n";
},"useData":true});
    }).call(this);
  